import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../services/UserContext";
import { API } from "../services/config";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RegisterPage() {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    especialidad: "",
  });
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.name || !form.phone || !form.password) {
      setError("Nombre, teléfono y contraseña son obligatorios");
      toast.error("Nombre, teléfono y contraseña son obligatorios");
      return;
    }

    const parts = form.name.trim().split(/\s+/);
    const nombre = parts[0] || form.name;
    const apellido = parts.slice(1).join(" ") || nombre;

    try {
      const response = await axios.post(`${API}/register`, {
        name: form.name,
        email: form.email || undefined,
        phone: form.phone,
        password: form.password,
        profesional: {
          nombre,
          apellido,
          celular: form.phone,
          mail: form.email || undefined,
          matricula: form.especialidad || undefined,
        },
      });

      const authUser = {
        ...response.data.user,
        profesional: response.data.profesional || null,
      };
      setUser(authUser);
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(authUser));

      toast.success("¡Cuenta creada! Bienvenido a Turnero");

      setTimeout(() => navigate("/", { replace: true }), 1200);
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (err.response?.data?.errors
          ? Object.values(err.response.data.errors).flat().join(" ")
          : null) ||
        "Error en el registro";
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <div className="login-widget-container login-bg-abstract">
      <div className="login-widget-abstract-art">
        <img
          src={require("../assets/00.png")}
          alt="Arte abstracto registro"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "40px 40px 120px 40px/60px 60px 120px 60px",
          }}
        />
      </div>
      <form className="login-widget-form login-form-ig" onSubmit={handleSubmit}>
        <h2
          className="login-widget-title login-title-ig"
          style={{ fontFamily: "Arial, Helvetica, sans-serif" }}
        >
          Crear tu cuenta profesional
        </h2>
        <p style={{ fontSize: 14, color: "#64748b", margin: "0 0 12px", textAlign: "center" }}>
          Calendario y WhatsApp incluidos
        </p>
        <input
          type="text"
          name="name"
          placeholder="Nombre y Apellido"
          value={form.name}
          onChange={handleChange}
          required
          className="login-widget-input login-input-ig"
        />
        <input
          type="text"
          name="especialidad"
          placeholder="Especialidad (opcional)"
          value={form.especialidad}
          onChange={handleChange}
          className="login-widget-input login-input-ig"
        />
        <input
          type="email"
          name="email"
          placeholder="Email (opcional)"
          value={form.email}
          onChange={handleChange}
          className="login-widget-input login-input-ig"
        />
        <input
          type="text"
          name="phone"
          placeholder="Teléfono WhatsApp"
          value={form.phone}
          onChange={handleChange}
          required
          className="login-widget-input login-input-ig"
        />
        <input
          type="password"
          name="password"
          placeholder="Contraseña (mín. 6 caracteres)"
          value={form.password}
          onChange={handleChange}
          required
          minLength={6}
          className="login-widget-input login-input-ig"
        />
        {error && <div style={{ color: "#e50914", fontSize: 14 }}>{error}</div>}
        <button className="login-widget-btn login-btn-ig" type="submit">
          Crear mi cuenta
        </button>
        <button
          type="button"
          className="login-widget-btn login-btn-ig"
          style={{ background: "#23234a", color: "#fff", marginTop: 8 }}
          onClick={() => navigate("/login")}
        >
          Ya tengo cuenta · Iniciar sesión
        </button>
      </form>
      <ToastContainer position="top-center" autoClose={1500} hideProgressBar theme="colored" />
    </div>
  );
}
